import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular-ivy';

Sentry.init({
  dsn: environment.sentryDSN,
  integrations: [
    new Sentry.BrowserTracing({
      tracingOrigins: ['localhost', `${environment.apiUrl}`],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
    new Sentry.TryCatch(),
    new Sentry.Replay(),
  ],
  tracesSampleRate: 1.0, 
  replaysOnErrorSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  environment: environment.production ? 'production' : 'development',
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((error: any) => console.error(error));
